<script>
import { Bar } from 'vue-chartjs';

export default {
  extends: Bar,
  props: {
    labels: {
      type: Array,
      default: () => { return []; },
    },
    data: {
      type: Object,
      default: () => {},
    },
    tooltips: {
      type: Object,
      default: () => {},
    },
  },
  data: function () {
    return {
      chartdata: {
        labels: this.labels,
        datasets: [
          {
            label: 'Standard',
            backgroundColor: '#2596be',
            data: this.data.customerSpecific,
            tooltips: this.tooltips.customerSpecific,
            categoryPercentage: 0.5,
            order: 1,
          },
          {
            label: 'Klubbunika',
            backgroundColor: '#9925be',
            data: this.data.standard,
            tooltips: this.tooltips.standard,
            categoryPercentage: 0.5,
            order: 1,
          },
          {
            label: 'Total',
            backgroundColor: '#F7882F',
            data: this.data.total,
            tooltips: this.tooltips.total,
            categoryPercentage: 0,
            order: 1,
          },
        ],
      },
      options: {
        legend: {
          labels: {
            filter: function(label) {
              if (label.text !== 'Total') return true;
            },
          },
        },
        scales: {
          xAxes: [{
            ticks: {
              beginAtZero: true,
            },
          }],
        },
        tooltips: {
          mode: 'label',
          callbacks: {
            label: function(tooltipItem, data) {
              var label = data.datasets[tooltipItem.datasetIndex].label || '';

              if (label) {
                label += ': ';
              }
              label += data.datasets[tooltipItem.datasetIndex].tooltips[tooltipItem.index];
              return label;
            },
          },
        },
        maintainAspectRatio: false,
      },
    };
  },

  mounted () {
    this.renderChart(this.chartdata, this.options);
  },
};
</script>
